import { useEffect, useState } from 'react';
import { Users, Phone, Mail, Calendar, Plane, Globe, PhoneCall } from 'lucide-react';

// import ThankYouPage from './components/ThankYouPage';
import Select from "react-select";
import { GetCountryList } from '../../Redux/Action/CorporateAction';
import { useDispatch, useSelector } from 'react-redux';
import { toast } from 'react-toastify';
import axios from 'axios';
import { useLocation, useNavigate } from 'react-router';
import Loader from './Loader';
import animationData from '../../images/registration.json'
import doctorimg from '../../images/Login/pleased-middle-aged-female-doctor-wearing-medical-robe-with-stethoscope-sitting-desk-work-laptop-with-medical-tools-speaks-phone-points-with-hand-side-green-wall (1).jpg'

function App() {
    const [countryCodeoption, setCountryCodeOption] = useState("");
    const [isloading, setIsloading] = useState(false);
    const dispatch = useDispatch();
    const navigate = useNavigate();
    const { search } = useLocation();
    const params = new URLSearchParams(search);
    const branchId = params.get("_id")
    // console.log(id)

    const defaultOption = {
        loop: true,
        autoplay: true,
        animationData: animationData,
    };
    const [formData, setFormData] = useState({
        name: '',
        email: '',
        mobile: '',
        countryCode: 91,
        sourceCountry: '',
        destinationCountry: ''
    });

    const handleInputChange = (e) => {
        const { name, value } = e.target;
        setFormData(prev => ({
            ...prev,
            [name]: value
        }));
    };

    const [countryOption, setCountryOption] = useState("");

    useEffect(() => {
        dispatch(GetCountryList());
    }, [dispatch]);

    const countryList = useSelector((state) => state?.corporateData?.CountryList?.data);

    useEffect(() => {
        if (countryList && countryList?.length > 0) {
            const con = countryList.map((item) => ({
                label: item.name,
                value: item.id,
                phonecode: item.phonecode,
            }));
            setCountryOption(con);
        }
    }, [countryList]);
    useEffect(() => {
        if (countryList && countryList?.length > 0) {
            const con = countryList.map((item) => ({
                label: `+${item.phonecode}`,
                value: item.phonecode,
            }));
            setCountryCodeOption(con);
        }
    }, [countryList]);

    // for payment
    const handleSubmit = async (e) => {
        e?.preventDefault();

        try {

            const data = { currency: "INR", amount: 300 };
            const response = await axios.post(`${process.env.REACT_APP_API_BASE_URL}/book-consultation`, data);
            const newdata = response.data.data;
            // console.log("Order Data:", newdata);
            if (!newdata) {
                alert("Error creating order!");
                return;
            }
            const options = {
                key: process.env.REACT_APP_RAZORPAY_KEY_ID,
                amount: newdata.amount,
                currency: "INR",
                name: "Welcome Cure Pvt. Ltd.",
                description: "Test Transaction",
                order_id: newdata.id,
                handler: async function (response) {
                    // console.log("Payment Response:", response);

                    const paymentData = {
                        orderId: response.razorpay_order_id,
                        paymentID: response.razorpay_payment_id,
                        signatureID: response.razorpay_signature,
                        countryCode: Number(formData.countryCode),
                        name: formData.name,
                        contact: Number(formData.mobile),
                        email: formData.email,
                        sourceCountry: formData.sourceCountry,
                        destinationCountry: formData.destinationCountry
                    };
                    setIsloading(true)
                    try {
                        const verifyResponse = await axios.post(`${process.env.REACT_APP_API_BASE_URL}/verify-payment`, paymentData);
                        if (verifyResponse.data.success) {
                            toast.success(verifyResponse.data.message);
                            navigate(`/thankyou?e_id=${newdata.id}`)
                            setIsloading(false)
                        } else {
                            setIsloading(false);
                        }
                    } catch (verifyError) {
                        console.error("Verification Error:", verifyError);
                        alert("Payment Verification Failed!");
                        setIsloading(false)
                    }
                },
                theme: { color: "#2563eb" },
                onPaymentError: function (response) {
                    console.error("Payment failed", response);
                    alert(`Payment Failed: ${response.error.description}`);
                },
                modal: {
                    ondismiss: function () {
                        setIsloading(false);
                    }
                }
            };

            const rzp = new window.Razorpay(options);
            rzp.open();
        } catch (error) {
            console.error("Payment failed", error);
            alert("Payment failed!");
        } finally {
            setIsloading(false);
        }
    };

    const customStyles = {
        control: (provided, state) => ({
            ...provided,
            // minWidth: '150px',
            // maxWidth: window?.innerWidth > 600 && '210px',
            borderColor: state.isFocused ? '#fff100' : '#ececec',
            boxShadow: 'none',
            backgroundColor: '#fff',
            '&:hover': { borderColor: '#ececec' },
        }),
        placeholder: (base) => ({
            ...base,
            color: '#262626',
        }),
        valueContainer: (provided) => ({
            ...provided,
            padding: '2px 8px',
            height: '38px',
            overflow: 'hidden',
        }),
        indicatorsContainer: (provided) => ({
            ...provided,
            color: '#262626',
            height: '38px',
        }),
        menu: (provided) => ({
            ...provided,
            zIndex: 9999,
        }),
        option: (provided, state) => ({
            ...provided,
            backgroundColor: 'transparent',
            color: 'black',
            display: 'flex',
            alignItems: 'center',
            '&:hover': {
                backgroundColor: '#f8f8f8',
            },
        }),
        menuList: (provided) => ({
            ...provided,
            maxHeight: '200px',
            overflowY: 'auto',
            padding: 0,
        }),
    };

    const customStylescountrycode = {
        control: (provided, state) => ({
            ...provided,
            minWidth: '100px',
            maxWidth: '150px',
            overflow: 'ellipsis',
            whiteSpace: 'nowrap',
            // maxWidth: window?.innerWidth > 600 && '210px',
            borderColor: state.isFocused ? '#fff100' : '#ececec',
            boxShadow: 'none',
            backgroundColor: '#fff',
            '&:hover': { borderColor: '#ececec' },
        }),
        placeholder: (base) => ({
            ...base,
            color: '#262626',
        }),
        valueContainer: (provided) => ({
            ...provided,
            padding: '2px 8px',
            height: '50px',
            overflow: 'hidden',
            borderColor: '#d1d5db'
        }),
        indicatorsContainer: (provided) => ({
            ...provided,
            color: '#262626',
            height: '50px',
        }),
        menu: (provided) => ({
            ...provided,
            zIndex: 9999,
        }),
        option: (provided, state) => ({
            ...provided,
            backgroundColor: 'transparent',
            color: 'black',
            display: 'flex',
            alignItems: 'center',
            '&:hover': {
                backgroundColor: '#f8f8f8',
            },
        }),
        menuList: (provided) => ({
            ...provided,
            maxHeight: '200px',
            overflowY: 'auto',
            padding: 0,
        }),
    };

    const customComponents = {
        IndicatorSeparator: () => null,
    };

    return (
        <>
            {isloading && (
                <div>
                    <div className="bg-black fixed  top-0 left-0 right-0 w-full h-full z-[999] bg-opacity-50">
                        <div className="z-[50] absolute top-1/2 left-1/2 transform -translate-x-1/2 -translate-y-1/2">
                            <Loader />
                        </div>
                    </div>
                </div>
            )}
            <div className="min-h-screen bg-gray-50">
                {/* Header */}
                <header className="bg-white shadow-lg sticky top-0 z-50 transition-all duration-300">
                    <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
                        <div className="flex justify-between items-center py-4">
                            <div className="flex items-center space-x-3">
                                <img src="data:image/png;base64,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"></img>
                            </div>
                        </div>
                    </div>
                </header>

                {/* Hero Section */}
                <section className="relative bg-gradient-to-br  from-blue-600 via-blue-700 to-blue-800 text-white">
                    {/* <div className="absolute inset-0 bg-black opacity-10"></div> */}

                    <div className="relative max-w-7xl flex flex-col py-10 lg:flex-row lg:items-center justify-between mx-auto px-4 sm:px-6 lg:px-8">
                        <div className="text-left">
                            <h2 className="text-3xl md:text-5xl font-bold mb-6 leading-tight">
                                Doctor on Call
                                <span className="block text-yellow-300">Your well-being is our top priority</span>
                            </h2>
                            <p className="text-xl md:text-2xl mb-8 text-blue-100 max-w-lg leading-relaxed">
                                Take care of your health, even when you're away from home.
                            </p>
                            <div className="flex flex-col sm:flex-row gap-4 justify-left">
                                <button
                                    onClick={() => {
                                        const section = document.getElementById("register");
                                        if (section) {
                                            section.scrollIntoView({ behavior: "smooth", block: "start" });
                                        }
                                    }}
                                    className="bg-[#FCDD00] text-center text-black px-8 py-4 rounded-full font-semibold text-lg hover:bg-yellow-400 transform hover:scale-105 transition-all duration-300 shadow-lg"
                                >
                                    Get Started Today
                                </button>
                            </div>
                        </div>
                        <div className="max-w-[100%] md:max-w-[100%] lg:max-w-[550px] mt-5 lg:mt-0">
                            {/* <Lottie options={defaultOption} /> */}
                            <img src={doctorimg} alt='doctorimg' className=' rounded-3xl'></img>
                        </div>
                    </div>

                </section>

                {/* Services Section */}
                <section id="services" className="py-20 bg-white">
                    <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
                        <div className="text-center mb-16">
                            <h3 className="text-4xl font-bold text-gray-900 mb-4">Our Doctor Consultation Service</h3>
                            <p className="text-xl text-gray-600 max-w-xl mx-auto">
                                Remote doctor consultations wherever you go. Activate doctor consultation services at just <span className='text-2xl font-bold'>₹300!</span>
                            </p>
                        </div>

                        <div className="grid md:grid-cols-3 gap-8 mb-16">
                            {/* Travel-Friendly Consultations */}
                            <div className="bg-gray-50 p-8 rounded-2xl text-center hover:shadow-xl transition-all duration-300 transform hover:-translate-y-2">
                                <div className="bg-blue-100 w-16 h-16 rounded-full flex items-center justify-center mx-auto mb-6">
                                    <Plane className="h-8 w-8 text-blue-600" />
                                </div>
                                <h4 className="text-2xl font-semibold text-gray-900 mb-4">
                                    Travel-Friendly Consultations
                                </h4>
                                <p className="text-gray-600 leading-relaxed">
                                    Designed for travelers on the move
                                </p>
                            </div>

                            {/* Seamless Telehealth Access */}
                            <div className="bg-gray-50 p-8 rounded-2xl text-center hover:shadow-xl transition-all duration-300 transform hover:-translate-y-2">
                                <div className="bg-green-100 w-16 h-16 rounded-full flex items-center justify-center mx-auto mb-6">
                                    <PhoneCall className="h-8 w-8 text-green-600" />
                                </div>
                                <h4 className="text-2xl font-semibold text-gray-900 mb-4">
                                    Seamless Telehealth Access
                                </h4>
                                <p className="text-gray-600 leading-relaxed">
                                    Get seamless medical support via tele-health
                                </p>
                            </div>

                            {/* Global Health Expertise */}
                            <div className="bg-gray-50 p-8 rounded-2xl text-center hover:shadow-xl transition-all duration-300 transform hover:-translate-y-2">
                                <div className="bg-purple-100 w-16 h-16 rounded-full flex items-center justify-center mx-auto mb-6">
                                    <Globe className="h-8 w-8 text-purple-600" />
                                </div>
                                <h4 className="text-2xl font-semibold text-gray-900 mb-4">
                                    Global Health Expertise
                                </h4>
                                <p className="text-gray-600 leading-relaxed">
                                    Consult with global experts
                                </p>
                            </div>
                        </div>

                        {/* Pricing Section */}
                        <div id="pricing" className="bg-gradient-to-r from-blue-50 to-indigo-50 p-8 rounded-3xl">
                            <div className="text-center mb-8">
                                <h4 className="text-3xl font-bold text-gray-900 mb-4">Transparent Pricing</h4>
                                <p className="text-lg text-gray-600">Quality healthcare consultation at an affordable rate</p>
                            </div>

                            <div className="max-w-md mx-auto bg-white p-8 rounded-2xl shadow-lg border-2 border-blue-200">
                                <div className="text-center">
                                    <div className="text-5xl font-bold text-blue-600 mb-2">₹300</div>
                                    <p className="text-gray-600 mb-6">Per Consultation</p>

                                    <ul className="text-left space-y-3 mb-8">
                                        <li className="flex items-center">
                                            <div className="w-2 h-2 bg-green-500 rounded-full mr-3"></div>
                                            <span className="text-gray-700">Health Consultations from Global Doctors</span>
                                        </li>
                                        <li className="flex items-center">
                                            <div className="w-2 h-2 bg-green-500 rounded-full mr-3"></div>
                                            <span className="text-gray-700">International / Local Prescriptions if required</span>
                                        </li>
                                        <li className="flex items-center">
                                            <div className="w-2 h-2 bg-green-500 rounded-full mr-3"></div>
                                            <span className="text-gray-700">Follow-up recommendations</span>
                                        </li>
                                        <li className="flex items-center">
                                            <div className="w-2 h-2 bg-green-500 rounded-full mr-3"></div>
                                            <span className="text-gray-700">Digital Health Records & Health Tips</span>
                                        </li>
                                    </ul>
                                </div>
                            </div>
                        </div>
                    </div>
                </section>

                {/* Registration Form */}
                <section id="register" className="pt-12 pb-20 bg-gray-50">
                    <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8">
                        <div className="text-center my-12">
                            <h3 className="text-4xl font-bold text-gray-900 mb-4">Book Your Consultation</h3>
                            <p className="text-xl text-gray-600">Fill in your details to get started with our Doctor on Call service</p>
                        </div>

                        <div className="bg-white px-4 py-6 md:py-8 md:px-8 rounded-3xl shadow-xl">
                            <form onSubmit={handleSubmit} className="space-y-6">
                                <div className="grid md:grid-cols-2 gap-6">
                                    <div>
                                        <label htmlFor="name" className="block text-sm font-semibold text-gray-700 mb-2">
                                            Full Name *
                                        </label>
                                        <input
                                            type="text"
                                            id="name"
                                            name="name"
                                            value={formData.name}
                                            onChange={handleInputChange}
                                            required
                                            className="w-full px-4 py-3 placeholder:text-[14px] md:placeholder:text-[16px] border border-gray-300 rounded-[4px] focus:ring-0 focus:ring-transparent focus:border-transparent transition-all duration-300"
                                            placeholder="Enter your full name"
                                        />
                                    </div>

                                    <div>
                                        <label htmlFor="email" className="block text-sm font-semibold text-gray-700 mb-2">
                                            Email Address *
                                        </label>
                                        <input
                                            type="email"
                                            id="email"
                                            name="email"
                                            value={formData.email}
                                            onChange={handleInputChange}
                                            required
                                            className="w-full px-4 py-3 placeholder:text-[14px] md:placeholder:text-[16px]  border border-gray-300 rounded-[4px] focus:ring-2 focus:ring-blue-500 focus:border-transparent transition-all duration-300"
                                            placeholder="Enter your email address"
                                        />
                                    </div>
                                </div>

                                <div>
                                    <label htmlFor="mobile" className="block text-sm font-semibold text-gray-700 mb-2">
                                        Mobile Number *
                                    </label>
                                    <div className="flex">
                                        <Select
                                            options={countryCodeoption}
                                            components={customComponents}
                                            placeholder="Select country code"
                                            name="countryCode"
                                            id="countryCode"
                                            value={countryCodeoption && countryCodeoption?.find((option) => option.value == formData.countryCode)}
                                            onChange={(e) => {
                                                setFormData(prev => ({
                                                    ...prev,
                                                    countryCode: e.value
                                                }));
                                            }}
                                            menuPlacement="top"
                                            isSearchable={true}
                                            styles={customStylescountrycode}
                                            required
                                        />
                                        <input
                                            type="number"
                                            id="mobile"
                                            name="mobile"
                                            value={formData.mobile}
                                            onChange={handleInputChange}
                                            required
                                            className="flex-1 placeholder:text-[14px] md:placeholder:text-[16px]  pl-2 sm:px-4 py-3 border border-l-0 border-gray-300 rounded-r-[4px] focus:ring-2 focus:ring-blue-500 focus:border-transparent transition-all duration-300"
                                            placeholder="Enter your mobile number"
                                        />
                                    </div>
                                </div>

                                <div className="grid md:grid-cols-2 gap-6">
                                    <div>
                                        <label htmlFor="sourceCountry" className="block text-sm font-semibold text-gray-700 mb-2">
                                            Source Country *
                                        </label>
                                        <Select
                                            options={countryOption}
                                            placeholder="Select Country"
                                            name="sourceCountry"
                                            id="sourceCountry"
                                            value={countryOption && countryOption?.find((option) => option.value === formData.sourceCountry)}
                                            onChange={(e) => {
                                                setFormData(prev => ({
                                                    ...prev,
                                                    sourceCountry: e.value
                                                }));
                                            }}
                                            menuPlacement="top"
                                            isSearchable={true}
                                            styles={customStyles}
                                            required
                                        />
                                    </div>

                                    <div>
                                        <label htmlFor="destinationCountry" className="block text-sm font-semibold text-gray-700 mb-2">
                                            Destination Country *
                                        </label>
                                        <Select
                                            options={countryOption}
                                            name="destinationCountry"
                                            id="destinationCountry"
                                            placeholder="Select Country"
                                            value={countryOption && countryOption?.find((option) => option.value === formData.destinationCountry)}
                                            onChange={(e) => {
                                                setFormData(prev => ({
                                                    ...prev,
                                                    destinationCountry: e.value
                                                }));
                                            }}
                                            menuPlacement="top"
                                            isSearchable={true}
                                            styles={customStyles}
                                            required
                                        />
                                    </div>
                                </div>

                                <div className="text-center pt-6">
                                    <button
                                        type="submit"
                                        className="bg-[#FCDD00] hover:bg-yellow-400 text-black font-bold py-4 px-12 rounded-full md:text-lg transform hover:scale-105 transition-all duration-300 shadow-lg hover:shadow-xl"
                                    >
                                        Pay ₹300 & Book Now
                                    </button>
                                </div>
                            </form>
                        </div>
                    </div>
                </section>

                {/* Footer */}
                <footer id="contact" className="bg-gray-900 text-white py-16">
                    <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
                        <div className="grid md:grid-cols-2 gap-12">
                            <div>
                                <div className="flex items-center space-x-3 mb-6">
                                    <img src="data:image/png;base64,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"></img>
                                </div>

                                <h4 className="text-2xl font-bold mb-4 text-yellow-300">Waiting To Welcome You Onboard!</h4>
                                <p className="text-gray-300 leading-relaxed mb-6">
                                    Join us on this journey towards a healthier you!
                                </p>
                            </div>

                            <div className="space-y-6">
                                <h4 className="text-xl font-semibold mb-6">Contact Information</h4>

                                <div className="flex items-center space-x-3">
                                    <Calendar className="h-5 w-5 text-blue-400" />
                                    <span className="text-gray-300">Mon - Saturday: 11am-5pm</span>
                                </div>

                                <div className="flex items-center space-x-3">
                                    <Users className="h-5 w-5 text-blue-400" />
                                    <span className="text-gray-300">Derick Fernandes</span>
                                </div>

                                <div className="flex items-center space-x-3">
                                    <Phone className="h-5 w-5 text-blue-400" />
                                    <a href="tel:9833593336" className="text-gray-300 hover:text-yellow-300 transition-colors">
                                        98335 93336
                                    </a>
                                </div>

                                <div className="flex items-center space-x-3">
                                    <Mail className="h-5 w-5 text-blue-400" />
                                    <a href="mailto:derick@welcomecure.com" className="text-gray-300 hover:text-yellow-300 transition-colors">
                                        derick@welcomecure.com
                                    </a>
                                </div>
                            </div>
                        </div>

                        <div className="border-t border-gray-800 mt-12 pt-8 text-center">
                            <p className="text-gray-400">
                                © {new Date().getFullYear()} Welcome Cure Pvt. Ltd. All rights reserved. | Professional healthcare consultation services.
                            </p>
                        </div>
                    </div>
                </footer>
            </div>
        </>
    );
}

export default App;